module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_16.ff5776e7.pdf";